<template>
    <div v-wechat-title="title" class="padding10">
        <h1>{{ today }}
            <el-switch v-model="onlySurgery" @change="changeList()"></el-switch>
        </h1>
        <el-row v-if="monitors && monitors.length > 0">
            <el-col :xl="defaultOperatingRoomCount" :md="defaultOperatingRoomCount" v-for="(p, index) in monitors" :key="index + '_' + ((p.surgery_info && p.surgery_info.id) || '')" class="padding5">
                <el-card :body-style="{ padding: '5px' }">
                    <div class="card-header">
                        <el-row class="height40 padding10 padding-none-v" type="flex" align="middle">
                            <el-col :span="23" style="line-height: 40px">
                                <b>{{ p.location }}</b>
                                <span v-if="IsRescue(p)" style="background-color: red; font-size: smaller; color: white">抢救中</span>
                                &nbsp;&nbsp;
                                <span class="iconfont icon-tishi" title="当前手术间未具备手术资格" v-if="p.check_result == '不合格'"></span>
                                <span v-if="p.surgery_info" style="float: right">
                                    <b class="fg-primary">{{ p.surgery_info.patient_name }}</b>
                                    {{ p.surgery_info && `${p.surgery_info.sex || '--'}/${p.surgery_info.age || '--岁'}` }}
                                </span>
                                <template v-else>(空)</template>
                            </el-col>
                            <el-col :span="1" class="align-right" title="查看波形图监控">
                                <font-awesome-icon v-if="p.surgery_info" class="screenfull-svg" icon="expand-alt" @click="loadView(p)" />
                            </el-col>
                        </el-row>
                    </div>
                    <div class="card-content">
                        <div :style="{ height: `${autoheight()}px` }" wrap-class="scrollbar-wrapper-y" v-if="p.surgery_info && p.surgery_info.patient_name">
                            <el-row>
                                <el-col :span="24" class="padding10">
                                    <el-row v-show="checkField(1)"
                                        ><el-col :span="12"><span class="fg-info textoverflow">身高：</span>{{ p.surgery_info && p.surgery_info.height }}</el-col>
                                        <el-col :span="12"><span class="fg-info textoverflow">体重：</span>{{ p.surgery_info && p.surgery_info.weight }}</el-col>
                                    </el-row>
                                    <el-row v-show="checkField(2)" style="max-height: 50px" :title="(p.surgery_info && p.surgery_info.diseases) || '--'">
                                        <el-col :span="24" style="font-size: 16px" class="ellipsis padding-none-h"
                                            ><span class="fg-info textoverflow">手术诊断：</span>{{ (p.surgery_info && p.surgery_info.diseases) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row v-show="checkField(3)" style="max-height: 50px" :title="(p.surgery_info && p.surgery_info.surgeries) || '--'">
                                        <el-col :span="24" style="font-size: 16px" class="ellipsis padding-none-h"
                                            ><span class="fg-info textoverflow">手术名称：</span>{{ (p.surgery_info && p.surgery_info.surgeries) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row v-show="checkField(4)" :title="(p.surgery_info && p.surgery_info.anaes_methods) || '--'">
                                        <el-col :span="24" style="font-size: 16px" class="ellipsis padding5 padding-none-h"
                                            ><span class="fg-info textoverflow">麻醉方式：</span>{{ (p.surgery_info && p.surgery_info.anaes_methods) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row v-show="checkField(5)">
                                        <el-col :span="12" :title="(p.surgery_info && p.surgery_info.surgeon) || '--'">手术医师：{{ (p.surgery_info && p.surgery_info.surgeon) || '--' }}</el-col>
                                        <el-col :span="12" :title="(p.surgery_info && p.surgery_info.anes_doctor) || '--'">麻醉医师：{{ (p.surgery_info && p.surgery_info.anes_doctor) || '--' }}</el-col>
                                    </el-row>
                                    <el-row v-show="checkField(6)">
                                        <el-col :span="12" :title="(p.surgery_info && p.surgery_info.surgeon_assistants) || joinWorker(p.surgery_info.fact_anes_assistants)">手术助手：{{ (p.surgery_info && p.surgery_info.surgeon_assistants) || joinWorker(p.surgery_info.fact_anes_assistants) }}</el-col>
                                        <el-col :span="12" :title="(p.surgery_info && p.surgery_info.anes_assistants) || '--'">麻醉助手：{{ (p.surgery_info && p.surgery_info.anes_assistants) || '--' }}</el-col>
                                    </el-row>
                                    <el-row v-show="checkField(7)">
                                        <el-col :span="12" :title="(p.surgery_info && p.surgery_info.circuit_nurse) || joinWorker(p.surgery_info.fact_equipment_nurse)">巡回护士：{{ (p.surgery_info && p.surgery_info.circuit_nurse) || joinWorker(p.surgery_info.fact_equipment_nurse) }}</el-col>
                                        <el-col :span="12" :title="(p.surgery_info && p.surgery_info.equipment_nurse) || joinWorker(p.surgery_info.fact_circuit_nurse)">器械护士：{{ (p.surgery_info && p.surgery_info.equipment_nurse) || joinWorker(p.surgery_info.fact_circuit_nurse) }}</el-col>
                                    </el-row>
                                    <el-row class="dt ellipsis padding-none-h" v-show="checkField(8)"
                                        ><el-col :span="24">麻醉开始时间：<text-formatter type="datetime" v-model="p.surgery_info.anesthesia_begin" v-if="p.surgery_info"></text-formatter></el-col
                                    ></el-row>
                                    <el-row style="width: 100%; height: 260px;" v-if="p.wave_url">
                                        <el-col :span="24" style="width: 100%; height: 100%;">
                                            <!-- <iframe src="http://portal.meehealth.com/wave/new?devicecode=tcphl7&devicemodel=DEM0001" style="width: 100%; height: 100%;"></iframe> -->
                                            <iframe :src="p.wave_url" style="width: 100%; height: 100%;"></iframe>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="no-bed" v-else :style="{ height: `${autoheight()}px` }">
                            <font-awesome-icon :icon="['fas', 'bed']"></font-awesome-icon>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <p v-else class="no-surgery">暂无手术间</p>

        <!-- 弹窗 -->
        <el-dialog ref="tk" title="查看术中波形图监控" :visible.sync="dialogVisible" width="95%" top="15vh">
            <div v-if="operationRoomMonitor" style="height: 100%">
                <div :body-style="{ padding: '5px', height: '100%' }">
                    <div class="card-header-dialog">
                        <el-row class="height40 padding10 padding-none-v" type="flex" align="middle">
                            <el-col :span="22" style="line-height: 40px">
                                <b>{{ operationRoomMonitor.location }}</b>
                                <span v-if="IsRescue(operationRoomMonitor)" style="background-color: red; font-size: smaller; color: white">抢救中</span>
                                &nbsp;&nbsp;
                                <span class="iconfont icon-tishi" title="当前手术间未具备手术资格" v-if="operationRoomMonitor.check_result == '不合格'"></span>
                                <span v-if="operationRoomMonitor.surgery_info" style="float: right">
                                    <b class="fg-primary">{{ operationRoomMonitor.surgery_info.patient_name }}</b>
                                    {{ operationRoomMonitor.surgery_info && `${operationRoomMonitor.surgery_info.sex || '--'}/${operationRoomMonitor.surgery_info.age || '--岁'}` }}
                                </span>
                                <template v-else>(空)</template>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="card-content-dialog fontClass">
                        <el-row>
                            <el-col :span="24" class="padding10">
                                <div class="fontClass">
                                    <el-row v-show="checkField(1)" style="max-height: 50px"
                                        ><el-col :span="12"><span class="fg-info">身高：</span>{{ operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.height }}</el-col>
                                        <el-col :span="12"><span class="fg-info">体重：</span>{{ operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.weight }}</el-col>
                                    </el-row>
                                    <el-row v-show="checkField(2)" style="max-height: 50px">
                                        <el-col :span="24"
                                            ><span class="fg-info">手术诊断：</span>{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.diseases) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row v-show="checkField(3)" style="max-height: 50px">
                                        <el-col :span="24"
                                            ><span class="fg-info">手术名称：</span>{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.surgeries) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row v-show="checkField(4)" style="max-height: 50px">
                                        <el-col :span="24" class="ellipsis padding5 padding-none-h"
                                            ><span class="fg-info">麻醉方式：</span>{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.anaes_methods) || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row v-show="checkField(5)" style="max-height: 50px"
                                        ><el-col :span="12">手术医师：{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.surgeon) || '--' }}</el-col
                                        ><el-col :span="12"
                                            >麻醉医师：{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.anes_doctor) || '--' }}</el-col
                                        ></el-row
                                    >
                                    <el-row v-show="checkField(6)" style="max-height: 50px"
                                        ><el-col :span="12">手术助手：{{
                                                (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.surgeon_assistants) ||
                                                joinWorker(operationRoomMonitor.surgery_info.fact_anes_assistants)
                                            }}</el-col
                                        ><el-col :span="12"
                                            >麻醉助手：{{ (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.anes_assistants) || '--' }}</el-col
                                        ></el-row
                                    >
                                    <el-row v-show="checkField(7)" style="max-height: 50px"
                                        ><el-col :span="12"
                                            >巡回护士：{{
                                                (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.circuit_nurse) ||
                                                joinWorker(operationRoomMonitor.surgery_info.fact_equipment_nurse)
                                            }}</el-col
                                        >
                                        <el-col :span="12"
                                            >器械护士：{{
                                                (operationRoomMonitor.surgery_info && operationRoomMonitor.surgery_info.equipment_nurse) ||
                                                joinWorker(operationRoomMonitor.surgery_info.fact_circuit_nurse)
                                            }}</el-col
                                        >
                                    </el-row>
                                    <el-row class="dt" v-show="checkField(8)" style="max-height: 50px"
                                        ><el-col :span="24"
                                            >麻醉开始时间：<text-formatter
                                                type="datetime"
                                                v-model="operationRoomMonitor.surgery_info.anesthesia_begin"
                                                v-if="operationRoomMonitor.surgery_info"
                                            ></text-formatter></el-col
                                    ></el-row>
                                    <el-row style="width: 100%;"  :style="{ height: `${dheight()}px` }" v-if="operationRoomMonitor.wave_url">
                                        <el-col :span="24" style="width: 100%; height: 100%;">
                                            <!-- <iframe src="http://portal.meehealth.com/wave/new?devicecode=tcphl7&devicemodel=DEM0001" style="width: 100%; height: 100%;"></iframe> -->
                                            <iframe :src="operationRoomMonitor.wave_url" style="width: 100%; height: 100%;"></iframe>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `SupervisionSurgeryWave`,
    components: { },
    props: {},
    data() {
        let roomCountspan = 8
        let roomCount = parseInt(this.$root.WaveformDefaultOperatingRoomCount || `3`)
        if (roomCount) {
            var count = 0
            if (roomCount > 8) {
                count = 8
            } else if (roomCount <= 0) {
                count = 1
            } else {
                count = roomCount
            }
            roomCountspan = 24 / count
        } else {
            roomCountspan = 8
        }
        return {
            title: `术中监控波形图`,
            monitors: [],
            loadFirst: true,
            onlySurgery: true,
            checklocationid: ``,
            today: this.$moment().format(`YYYY/MM/DD dddd `),
            operationRoomMonitor: null,
            dialogVisible: false,
            isShowOperatingDefaultField: 0,
            nameFontSize: `28px`,
            dataFontSize: `38px`,
            rowTototalHeight: 0,
            pHeight: 0,
            defaultOperatingRoomCount: roomCountspan, // 手术间个数配置
            fieldConfig: (this.$root.WaveformDefaultFieldConfig || `2|3|4|5`).split(`|`).map(d => parseInt(d)), // 术中监控波形图页面手术信息显示配置
            urlConfig: this.$root.WaveformUrlConfig // 术中监控波形图页面URL配置
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `active_ward`])
    },
    mounted() {
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.loadSurgeries()
    },
    created() {
        let that = this
        clearInterval(that.interval)
        that.interval = setInterval(() => {
            that.today = this.$moment().format(`YYYY/MM/DD dddd `)
            that.loadSurgeries()
        }, 300000)
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    methods: {
        changeList() {
            console.log(this.onlySurgery)
        },
        checkField(num) {
            let that = this
            return that.fieldConfig && _.includes(that.fieldConfig, num)
        },
        IsRescue(p) {
            if (p.surgery_info && p.surgery_info.rescue_segment &&
                p.surgery_info.rescue_segment.begin_time && p.surgery_info.rescue_segment.end_time === null) {
                return true
            }
            return false
        },
        autoheight() {
            let that = this
            let contentMinHeight = 275
            let fieldCount = (that.fieldConfig && _.filter(that.fieldConfig, d => d !== 0) || []).length || 0
            if (that.fieldConfig) {
                contentMinHeight += (28 * fieldCount)
            }
            this.rowTototalHeight = contentMinHeight
            console.log(`rowTototalHeight`, this.rowTototalHeight)
            return this.rowTototalHeight
        },
        loadSurgeries() {
            let that = this
            if (!that.active_ward || !that.active_ward.operation_room) {
                that.monitors = []
                return
            }
            that.myaxios.post(
                `/api/Operation/Monitor/OperatingSurgeryInfos`,
                _.map(that.active_ward.operation_room, d => d.value)
            ).then((surgeries) => {
                let monitors = _.map(
                    _.filter(that.active_ward.operation_room, d => !d.disabled),
                    d => {
                        let surgeryInfo = _.find(surgeries, s => s.dic_operating_room_id == d.value)
                        let waveurl = ``
                        if (surgeryInfo && surgeryInfo.devices && surgeryInfo.devices[0]) {
                            let iurl = _.cloneDeep(that.urlConfig)
                            waveurl = iurl.replace(`@device_name`, surgeryInfo.devices[0].name)
                                .replace(`@waveform_type`, surgeryInfo.devices[0].waveform_type)
                                .replace(`@device_no`, surgeryInfo.devices[0].device_no)
                                .replace(`@device_bar_code`, surgeryInfo.devices[0].bar_code)
                        }
                        return {
                            location_id: d.value,
                            location: d.label,
                            check_result: `未检查`,
                            surgery_info: surgeryInfo,
                            wave_url: waveurl
                        }
                    }
                )
                if (that.onlySurgery) {
                    monitors = _.filter(monitors, d => d.surgery_info)
                }
                that.monitors = monitors
                console.log(`monitors`, monitors)

                if (that.checklocationid) {
                    var monitorEntityData = _.find(that.monitors, c => c.location_id == that.checklocationid)
                    if (monitorEntityData) { that.operationRoomMonitor = monitorEntityData }
                }
            })
        },
        joinWorker(arr) {
            return (arr && _.map(arr, d => d.label).toString()) || `--`
        },
        dheight() {
            let that = this
            console.log(`screenHeight`, that.screenHeight)
            let cheight = this.screenHeight * 0.85 - 100 // 获取高度
            console.log(`cheight`, cheight)
            let fieldCount = (that.fieldConfig && _.filter(that.fieldConfig, d => d !== 0) || []).length || 0
            if (that.fieldConfig) {
                cheight -= (50 * fieldCount)
            }
            this.pHeight = cheight
            console.log(`pHeight`, cheight)
            return this.pHeight
        },
        loadView(p) {
            if (p) {
                var that = this
                that.dialogVisible = true
                that.operationRoomMonitor = p
                that.checklocationid = p.location_id
            }
        }
    },
    watch: {
        active_ward: function() {
            this.loadSurgeries()
        },
        onlySurgery: function() {
            this.loadSurgeries()
        }
    }
}
</script>
<style  lang="less" scoped>
.textoverflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.card-header {
    text-align: left;
    font-size: 18px;
    font-family: Arial;
}
.card-header-dialog {
    text-align: left;
    font-size: 24px;
    font-family: Arial;
}
/deep/ .el-dialog__body {
    padding: 20px 20px 0 20px !important;
    overflow: auto;
    background: #fafafa;
    height: 85vh;
}
/deep/.el-dialog__body .div {
    height: auto;
}
.fontClass {
    font-size: 28px;
}
.card-content {
    height: 100%;
    text-align: left;
    background: #f5f6f7 !important;
    .hand {
        font-size: 14px;
    }
    .dt {
        color: darkgoldenrod;
    }
    .el-row {
        padding: 2px !important;
    }
}
.card-content-dialog {
    height: 100%;
    text-align: left;
    .hand {
        font-size: 14px;
    }
    .dt {
        color: darkgoldenrod;
    }
    .el-row {
        padding: 8px !important;
    }
}
h1 {
    text-align: left;
    padding: 0;
    font-size: 30px;
    margin: 0;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
.no-bed {
    background: gainsboro;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: lightgrey;
    font-size: 100px;
    background: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/Supervision/Index.vue